module.exports = __webpack_public_path__ + "static/media/H1_Large.477bc7a7.svg";